module.exports = __webpack_public_path__ + "img/traffic-junction-3.c51865a3.jpg";